export default __webpack_public_path__ + "static/media/fire.ea2349cd.svg";